import React, { FC } from "react"
import { makeStyles, Dialog, DialogContent, DialogContentText, DialogTitle, CircularProgress } from "@material-ui/core"

const useStyles = makeStyles(theme => ({

  loadPic: {
  display: "none",
  position: "fixed",
  width: "300px",
  height: "100%",
  alignItems: 'center',
  alignContent: "center"
  },
  
}))

  interface Props {
    pendingLoadingPicture: boolean,
    setPendingLoadingPicture: boolean,
    loadingSymbolText: string,
    open: boolean
  }

const LoadingSymbols: FC<Props> = ({pendingLoadingPicture, setPendingLoadingPicture, loadingSymbolText, open }) => {
    return(
      <div>
        <Dialog open={pendingLoadingPicture.valueOf()} aria-labelledby="loading-symbol" aria-describedby="loading-des" >
        <DialogTitle id="alert-dialog-title">{ loadingSymbolText}</DialogTitle>
        <DialogContent style={{display: "flex", alignContent: "center", alignSelf: "center", alignItems: "center"}}>
          <DialogContentText id="alert-dialog-description" >        
            < CircularProgress  />       
          </DialogContentText>   
        </DialogContent>
        </Dialog>     
      </div> 
    )
  }
export default LoadingSymbols